import React, { useState } from "react";
import { IconZoomIn } from "@tabler/icons-react";
import axios from "../../../library/axios";
import { Base64ViewerComp } from "../../";
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import { downloadDocumentWithAlert } from "../../../helpers/downloadDocument";
import { notifyApiLoadError } from '../../../helpers/notifyApiError';

const ListDocumentForumComp = (props) => {
  const baseUrl = new URL(window.location.href);
  const [link, setLink] = useState("");
  // Info dokumen (nama + deskripsi) untuk ditampilkan di modal viewer.
  const [docInfo, setDocInfo] = useState({
    namaFile: "",
    deskripsi: "",
    downloadPath: "",
  });
  const [isPdf, setisPdf] = useState("application/pdf");
  const [lgShowIframe, setLgShowIframe] = useState(false);

  const handleShowDocument = async (id) => {
    try {
      setLink("");
      setDocInfo({ namaFile: "", deskripsi: "", downloadPath: "" });
      const options = {
        url: `/skor/show-dokumen/${id}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      if (data.data.mimeType !== isPdf) {
        // Berkas non-PDF tidak bisa dirender viewer, jadi langsung diunduh --
        // lewat endpoint ber-auth, bukan URL statis, supaya group yang dilarang
        // mengunduh tetap tertahan di server.
        await downloadDocumentWithAlert(
          `/skor/download-dokumen/${id}`,
          data.data.namaFile
        );
        return false;
      }
      setDocInfo({
        namaFile: data?.data?.namaFile || "",
        deskripsi: data?.data?.Deskripsi || "",
        downloadPath: `/skor/download-dokumen/${id}`,
      });
      const concatUrl = baseUrl.origin.concat(`/${data.data.link}`);
      setLgShowIframe(true);
      setLink(concatUrl);
    } catch (err) {
      setLgShowIframe(false);
      notifyApiLoadError(err, 'components/moleculs/forum/list-documents.handleShowDocument');
    }
  };

  return (
    <>
      <table className="table table-row-dashed table-row-gray-300 gy-7">
        <thead className="bg-primary text-white">
          <tr className="fw-bolder fs-6">
            <th className="text-center">Aksi</th>
            <th className="text-center">Nama File</th>
          </tr>
        </thead>
        <tbody>
          {props?.documents?.map((document) => (
            <tr>
              <td className="text-center">
                <button
                  onClick={() => handleShowDocument(document.id)}
                  className="btn btn-primary btn-sm"
                  type="button"
                >
                  <IconZoomIn stroke={2} /> Download File
                </button>
              </td>
              <td>
                {document.namaFile}
                <br></br>
                <i className="fs-8">
                  {document.createdAt} by {document.createdBy}
                </i>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {lgShowIframe === true ? (
        <Base64ViewerComp
          link={link}
          namaFile={docInfo.namaFile}
          deskripsi={docInfo.deskripsi}
          downloadPath={docInfo.downloadPath}
          close={() => setLgShowIframe(false)}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default ListDocumentForumComp;
